/* customGroup/types */
import * as t from "io-ts";

function tOptional<T extends t.Mixed>(typeThing: T) {
  return t.union([t.undefined, t.null, typeThing]);
}
const tId = t.union([t.undefined, t.null, t.string]);

const ErrorCodec = t.type(
  {
    code: t.string,
    detail: t.string,
    title: t.string,
  },
  "ErrorCodec"
);

export const DataCodec = t.intersection([
  t.type({
    _id: tId,
    name: t.string,
    groupId: t.number,
    type: tOptional(t.string),
  }),
  t.partial({
    createdAt: t.string,
    updatedAt: t.string,
  }),
]);

export type Data = t.TypeOf<typeof DataCodec>;

export const CustomGroupCodec = t.type(
  {
    errors: tOptional(t.union([t.undefined, t.array(ErrorCodec)])),
    data: tOptional(t.array(DataCodec)),
  },
  "CustomGroupCodec"
);

export type CustomGroup = t.TypeOf<typeof CustomGroupCodec>;

export enum CustomGroupActionTypes {
  FETCH = "@@customGroup/FETCH",
  FETCH_SUCCESS = "@@customGroup/FETCH_SUCCESS",
  FETCH_ERROR = "@@customGroup/FETCH_ERROR",
  CREATE = "@@customGroup/CREATE",
  SAVE_REQUEST = "@@customGroup/SAVE_REQUEST",
  SAVE_SUCCESS = "@@customGroup/SAVE_SUCCESS",
  SAVE_ERROR = "@@customGroup/SAVE_ERROR",
  DELETE_REQUEST = "@@customGroup/DELETE_REQUEST",
  DELETE_SUCCESS = "@@customGroup/DELETE_SUCCESS",
  DELETE_ERROR = "@@customGroup/DELETE_ERROR",
}

export interface CustomGroupState {
  readonly loading: boolean;
  readonly data: CustomGroup | undefined;
  readonly errors?: string;
}
